// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__Ay-bE","errorLogs":"styles_errorLogs__3S8xg"};